<template>
    <div :class="['align-c year', classes.priorityType, Classes().voidYear]">
        <span class="void-year-message" v-if="VoidCurrentYear()">In progress</span>
        <Day v-for="(day, d) in CONFIG.timeline.daysPerMonth" :key="d"/>
    </div>
</template>

<script>
import Day from "@/components/Timeline/Day.vue";
import { CONFIG } from "@/assets/JS/Config.js";

export default {
    name: "TimelineYear",
    props: {
        year: Object,
        priority: Object
    },
    components: { Day },
    data: () => ({
        classes: { priorityType: "" },
        CONFIG
    }),
    methods: {
        Classes: function() {
            return { voidYear: this.VoidCurrentYear() ? "void-year" : "" };
        },
        VoidCurrentYear: function() {
            if (this.priority.counts) {
                return this.priority.counts.TotalCurrentYearProjects === 0 && this.year.year === new Date().getFullYear();
            }
            return false;
        }
    },
    beforeMount: function() {
        this.classes.priorityType = `year-priority-type-${this.year.priorityType.name.toLowerCase()}`;
    }
};
</script>